import Loadable from 'react-loadable';
import Loading from '../Loading';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "ResendRewardLink" */ '../../components/rewards/ResendRewardLink'),
  loading: Loading(),
});
